import { ActionTypes } from '../../constants/ActionTypes';
import { ILetterBodyImage } from '../../interfaces';

//////////////////////////////////////Change//////////////////////////////////////////////
export const onChangeLetterBodyImage = (payload: ILetterBodyImage) => {
  return {
    type: ActionTypes.CHANGE_LetterBodyImage,
    payload: payload,
  };
};
export const onClearLetterBodyImage = () => {
  return {
    type: ActionTypes.CLEAR_LetterBodyImage,
  };
};
